import { forEach, includes, remove } from 'lodash'
import { produce } from 'immer'
import { MetaData } from '../apis/meta.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'
import { AddonName } from '../apis/addon.api'

export default {
  isEditable (meta: MetaData) {
    const editables: Partial<AddonName>[] = [
      'extendInventoryCreateFormWhenItemEquals',
      'extendInventoryCreateFormWithActualWeight',
      'changePalletCode',
      'changeCaseCode',
      'extendInventoryCreateFormWhenCategoryNameEquals'
    ]
    return meta.addon && includes(editables, meta.addon.name)
  },

  tableHorizontalData (metas: MetaData[]): TableHorizontalData<MetaData>[] {
    forEach(metas, (meta: TableHorizontalData<MetaData>) => {
      const actions: ActionName[] = []
      if (this.isEditable(meta)) actions.push('edit')
      if (!meta.isDeleted) actions.push('delete')
      meta.actions = actions
    })
    return metas
  },

  delete (metas: TableHorizontalData<MetaData>[], id: number) {
    return produce(metas, metas => {
      remove(metas, { id })
    })
  }
}
